export default {
  __name: 'ActionModal',
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  emits: ["close-modal", "ok"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    // @ts-check

    return {
      __sfc: true,
      emit: emit
    };
  }
};